import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { resolve } from '@/infrastructure/container';
import { ud_di } from './di';
import { assertBootSubscribers } from './bootSubscribers';
import { type AppBus, TOKEN_IAppBus } from '@/services/AppBus';
import { AppView } from '@/views/AppView';
import { ErrorBoundaryView } from '@/views/ErrorBoundaryView';
import { TOKEN_AppStore } from '@/views/AppStore';
import { TOKEN_ImportsStore } from '@/views/ImportsStore';
import { TOKEN_LocaleStore } from '@/views/LocaleStore';
import { TOKEN_OnboardingStore } from '@/views/OnboardingStore';
import { TOKEN_ResultsStore } from '@/views/ResultsStore';
import { TOKEN_SimulationStore } from '@/views/SimulationStore';
import { TOKEN_ThemeStore } from '@/views/ThemeStore';
import { TOKEN_ToastStore } from '@/views/ToastStore';
import { TOKEN_WarningsStore } from '@/views/WarningsStore';

import './index.css';

ud_di();

// Eager-resolve subscribers before AppStore: it starts keyboard listening (a publisher).
resolve(TOKEN_LocaleStore);
resolve(TOKEN_OnboardingStore);
resolve(TOKEN_ThemeStore);
resolve(TOKEN_ToastStore);
resolve(TOKEN_WarningsStore);
resolve(TOKEN_ImportsStore);
resolve(TOKEN_SimulationStore);
resolve(TOKEN_ResultsStore);

assertBootSubscribers(resolve(TOKEN_IAppBus) as AppBus);

resolve(TOKEN_AppStore);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundaryView>
      <AppView />
    </ErrorBoundaryView>
  </StrictMode>,
);
